import { Api } from '@/services/AxiosService'
import { successMessage, errorMessage, checkAuth } from '@/helper'

const actions = {
  //only for log in users
  async fetchFavoriteFlatList(ctx) {
    if (!checkAuth()) return
    const {
      data: { data },
    } = await Api.fetchFavoriteFlatList()
    ctx.commit('setFavoriteFlatList', data)
  },

  async addToFavorite(ctx, flat) {
    ctx.commit('addToFavorite', flat)
    successMessage('Квартира додана в підбірку')
    if (!checkAuth()) return
    await Api.addToFavoriteFlatList(flat.id,'normal')
      .catch(() => errorMessage('Упс... Щось пішло не так'))
  },

  async moveTopFavorite(ctx, flat) {
    const res = !!!flat.is_sort_up
    ctx.commit('moveUpFavorite', { res, flat })
    if (!flat.is_sort_up) successMessage('Квартиру піднято вверх', '', 'topNotification')
    else  successMessage('Статус "Мій фаворит" знято')
    if (!checkAuth()) return
    await Api.moveTopFavorite(flat.id)
    .catch(() => errorMessage('Упс... Щось пішло не так'))
  },
  
  async moveBottomFavorite(ctx, flat) {
    const res = !!!flat.is_sort_down
    ctx.commit('moveBottomFavorite', { res, flat })
    if (!flat.is_sort_down) successMessage('Квартиру переміщено вниз', '', 'botNotification')
    else  successMessage('Статус "В роздумах" знято')
    if (!checkAuth()) return
    await Api.moveBottomFavorite(flat.id)
    .catch(() => errorMessage('Упс... Щось пішло не так'))
  },

  async deleteFromFavorite(ctx, flat) {
    ctx.commit('deleteFromFavorite', flat)
    successMessage('Квартиру видалено з підбірки', '', 'removeNotification')
    if (!checkAuth()) return
    await Api.deleteFromFavoriteFlatList(flat.id)
      .catch(() => errorMessage('Упс... Щось пішло не так'))

  },

}
const mutations = {
  moveUpFavorite(state, { res, flat }) {
    const index = state.favoriteFlatList.findIndex((item) => item.id === flat.id)
    state.favoriteFlatList.splice(index, 1, { ...flat, is_sort_up: res, is_sort_down: false })
  },

  moveBottomFavorite(state, { res, flat }) {
    const index = state.favoriteFlatList.findIndex((item) => item.id === flat.id)
    state.favoriteFlatList.splice(index, 1, { ...flat, is_sort_down: res, is_sort_up: false })
  },

  setFavoriteFlatList(state, data) {
    state.favoriteFlatList = data
  },
  addToFavorite(state, flat) {
    state.favoriteFlatList.unshift({ ...flat, is_sort_down: false, is_sort_up: false })
  },
  deleteFromFavorite(state, flat) {
    const index = state.favoriteFlatList.findIndex(
      (item) => item.id === flat.id
    )
    state.favoriteFlatList.splice(index, 1)
  },
}
const getters = {
  getFavoriteFlatList(state) {
    return state.favoriteFlatList
  },
}

const state = {
  favoriteFlatList: [],
}

export default {
  state,
  getters,
  mutations,
  actions,
}
